export class IngestionPipelineDeadLetterErrorGroup {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": ""
        },
        {
            "name": "firstSeenAt",
            "baseName": "firstSeenAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastSeenAt",
            "baseName": "lastSeenAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "deadLetters",
            "baseName": "deadLetters",
            "type": "Array<IngestionPipelineDeadLetter>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineDeadLetterErrorGroup.attributeTypeMap;
    }
    constructor() {
    }
}
